import { render, staticRenderFns } from "./Cadastrar.vue?vue&type=template&id=ae4bfef8"
import script from "./Cadastrar.vue?vue&type=script&lang=js"
export * from "./Cadastrar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports